import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { isEmpty } from 'lodash'
import { CreateModalHubspotWrapper } from '../CreateModalHubspotWrapper/CreateModalHubspotWrapper'
import { useDispatch, useSelector } from '../../store'
import { PartnerType, usePartnerAccountDataActions } from '@labrav/common'

/**
 * HubSpot create-offer entry: partner account must be loaded first so
 * CreateModalHubspotWrapper can read crmId for marketplace templates.
 */
export const CreateModalHubspotRoute = () => {
  const dispatch = useDispatch()
  const { getAccount } = usePartnerAccountDataActions()
  const { partnerId } = useParams<{ partnerId: string }>()
  const { partnerData } = useSelector(state => state.AccountData.user)

  useEffect(() => {
    if (!partnerId) return
    if (isEmpty(partnerData) || partnerData?.partnerId !== partnerId) {
      dispatch(getAccount(partnerId, PartnerType.User) as never)
    }
  }, [partnerId, partnerData, dispatch, getAccount])

  const isPartnerReady =
    !isEmpty(partnerData) && partnerData?.partnerId === partnerId

  if (!isPartnerReady) {
    return <div data-testid="loading" />
  }

  return <CreateModalHubspotWrapper />
}
